/* global $:true */
import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-single-address-validation]";
const ELEMENT_SELECTOR_POSTCODE = "[data-postcode-autopopulate]";
const FORM_WRAPPER_SELECTOR = "data-form-wrapper-element";
const SINGLE_LINE_FIELD_SELECTOR = "data-single-line-field";
const SINGLE_LINE_FIELDS_SELECTOR = "data-single-line-fields";
const ADDRESS_LINE_0_SELECTOR = ".address-line-0";
const PLUGIN_NAME = "SingleAddressValidation";

class SingleAddressValidation {
  constructor(element, options) {
    this.element = element;
    this.options = options;
    this.$element = $(element);
    this.$parentEl = $(this.$element.attr(FORM_WRAPPER_SELECTOR));
    this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
    this.isSingleLine =
      typeof this.$element.attr(SINGLE_LINE_FIELD_SELECTOR) !== "undefined";
    this.singleLineFields =
      typeof this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) !== "undefined"
        ? this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR)
        : "";

    this.watchGoogleMapApiError();
    this.init();
    this.preventSubmit();
  }

  watchGoogleMapApiError() {
    const oldError = console.error;
    // Stops the input field from being disabled if issue with API
    const $element = this.$element;
    console.error = function(message) {
      if (message.toLowerCase().includes("google maps api error")) {
        $element.removeAttr("disabled");
        $element.attr("placeholder", "");
        $element.removeAttr("style", "");
        $element
          .parent()
          .find(".field-validation-valid")
          .hide();
      }

      oldError.apply(console, arguments);
    };
  }

  preventSubmit() {
    if (this.$element.closest("form").length) {
      this.$element.on("keydown", (event) => {
        //clear the hidden postcode field on keydown (forces the user to selected a suburb from the autocomplete list)
        $("[data-postcode-autopopulate] input").val("");

        if (event.keyCode === 13) {
          event.preventDefault();
          console.log("preventSubmit.keypress", event.keyCode);
        }
      });
    }
  }

  init() {
    var options = {
      types: ["address"],
      componentRestrictions: { country: this.options.countryCode },
    };

    var el = this.$element.attr("id");
    var thisElement = this.$element;
    window.autocompleteObj = new google.maps.places.Autocomplete(
      document.getElementById(el),
      options
    );

    this.autocomplete = window.autocompleteObj;
    this.autocomplete.addListener(
      "place_changed",
      this.fillInPostcode.bind(this)
    );

    var validator = this.$element.closest("form").validate();

    $("#" + el).rules("add", {
      validAddress: true,
    });

    jQuery.validator.addMethod(
      "validAddress",
      function(value, element) {
        if ($("div[data-postcode-autopopulate] input").val().length <= 0) {
          return false;
        } else {
          return true;
        }
      },
      "Please enter a valid address"
    );
  }

  fillInPostcode() {
    var inputElement = this.$element;

    //Retrieve postcode from lat/lng and populate the postcode form field
    var place = this.autocomplete.getPlace();

    /*console.log('place');
		console.log(place);
		console.log(place.geometry.location.lat());
		console.log(place.geometry.location.lng());*/

    var latlng = new google.maps.LatLng(
      place.geometry.location.lat(),
      place.geometry.location.lng()
    );
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ latLng: latlng }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        console.log(status);
      }
      // This is checking to see if the Geoeode Status is OK before proceeding
      if (status == google.maps.GeocoderStatus.OK) {
        //console.log('geocoder');
        //console.log(results);

        var address = results[0].formatted_address;

        var searchAddressComponents = results[0].address_components,
          searchPostalCode = "",
          searchSuburb = "";

        //console.log('searchAddressComponents');
        //console.log(searchAddressComponents);
        var suburbLocator = "locality";

        if (!searchAddressComponents.some((c) => c.types[0] === "locality")) {
          suburbLocator = "administrative_area_level_1"; //some of the NZ cities don't have locality level component, use administrative_area_level_1 instead. e.g. Auckland
        }

        $.each(searchAddressComponents, function() {
          if (this.types[0] === "postal_code") {
            searchPostalCode = this.short_name;
          }
          if (this.types[0] === suburbLocator) {
            searchSuburb = this.short_name;
          }
          // remove country name from full address value
          if (this.types[0] === "country" && address) {
            address = address
              .split(", ")
              .filter((a) => a !== this.long_name)
              .join(", ");
          }
        });

        $("[data-postcode-autopopulate] input").val(searchPostalCode);
        $("[data-suburb-postcode-noaddress-autosuggest] input").val(
          searchSuburb
        );

        if (address) {
          $("[data-single-line-address-autosuggest] input").val(address);
        }

        // validate the suburb input
        $(inputElement).valid();
      }
    });

    $(document).trigger("address-validation-complete");
  }
}

SingleAddressValidation.DEFAULTS = {
  countryCode: $(`meta[name="site.countryCode"]`).attr("content"),
};

plugin(PLUGIN_NAME, SingleAddressValidation);

$(document).ready(() => {
  $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/single-address-validation.js